
import React, { useMemo } from "react"
import { Box, Popover } from "@mui/material";
const PopoverBarebone = ({sx, children, component, anchorOrigin ={
  vertical: 'bottom',
  horizontal: 'center',
}, transformOrigin = {
  vertical: 'top',
  horizontal: 'center',
} }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const componentMod = useMemo(()=> {
    const result = React.cloneElement(component, { ...component.props, onClick: (e) => setAnchorEl(e.currentTarget) })
    return result
  }, [component])
  return (
    <Box sx={sx}>
      {componentMod}
      <Popover open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}>
        {children}
      </Popover>
    </Box>
  )
}

export default React.memo(PopoverBarebone)